import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Slides , Platform} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Broadcaster } from '../../app/broadcaster';
import { Config } from '../../app/app.config';

import { ApiService } from '../../app/services/api.service';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage'

@Component({
  selector: 'page-grid',
  templateUrl: 'grid.html',
  providers: [ApiService]
})

export class GridPage {

	@ViewChild('pageSlider') pageSlider: Slides;
	tabs: any = '0';
  items: Array<Array<{id: number, title: string, desc: string, thumb: string, price: number, like: number; liked: boolean, sub: any}>>;
  iCounter: Array<Array<number>>;
  iTotal: number;
  currentItem: {id: number, title: string, desc: string, thumb: string, price: number, like: number; liked: boolean, aIndex: number, iIndex: number};
  foodDetailState: string;
  heightPop: string;
  iconClicked: boolean;
  subMenu = JSON.parse(this._okageStorage.getItem('foods.submenu'));

  /**
   *
   * @param navCtrl
   * @param navParams
   * @param _apiService
   */
	constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private _apiService: ApiService,
              private storage: Storage,
              private _okageStorage: OkageStorageProvider,
              private broadcaster: Broadcaster,
              public platform: Platform) {
    this.currentItem = {
      id: 0,
      title: '',
      desc: '',
      thumb: '',
      like: -1,
      price: 0,
      liked: false,
      aIndex: -1,
      iIndex: -1
    };

    this.foodDetailState = '';
    this.iconClicked = false;

    this.broadcaster.on<number>('data.ready')
      .subscribe(state => {
        this.storage.get('foods.menu').then((v) => {
          this.items = v;
          this.foodCounterChanged();
        });
      });

    this.broadcaster.on<number>('submenuChanged')
      .subscribe(from => {
        if (from != 1) {
          let tmp = JSON.parse(this._okageStorage.getItem('foods.submenu'));
          for (var key in this.subMenu) {
            for (var j = 0; j < this.subMenu[key].length; j++) {
              this.subMenu[key][j].quantity = tmp[key][j].quantity;
            }
          }
        }
      });

    this.broadcaster.on<number>('foodCounterChanged')
      .subscribe(from => {
        if (from != 1) {
          this.foodCounterChanged();
        }
      });

    this.broadcaster.on<number>('foodLikeChanged')
      .subscribe(from => {
        if (from != 1) {
          this.foodLikeChanged();
        }
      });
  }

  foodCounterChanged() {
    this.iCounter = [];
    this.iTotal = 0;
    this.storage.get('foods.selected').then((v) => {
      if (v) {
        this.iCounter = v;

        for (var i = 0; i < this.items.length; i++) {
          for (var j = 0; j < this.items[i].length; j++) {
          //if (this.iCounter[i]) {
            //for (var j = 0; j < this.iCounter[i].length; j++) {
              //if (this.iCounter[i][j]) {
                if (typeof this.subMenu[this.items[i][j].id] !== 'undefined') {
                  this.items[i][j].sub = this.subMenu[this.items[i][j].id];
                }
              //}
            //}
          //}
          }
        }
      }
      this.countTotal();
    });
  }

  foodLikeChanged() {
    this.storage.get('foods.menu').then((m) => {
      if (m) {
        this.items = m;
      }
    });
  }

  detailPopup(aIndex, iIndex) {
    this.platform.ready().then(()=>{
      console.log('Width: ' + this.platform.width());
      console.log('Height: ' + this.platform.height());
      this.heightPop = String(this.platform.height() - 145)+'px';
    });
    this.currentItem = {
      id: this.items[aIndex][iIndex].id,
      title: this.items[aIndex][iIndex].title,
      desc: this.items[aIndex][iIndex].desc,
      thumb: this.items[aIndex][iIndex].thumb,
      like: this.items[aIndex][iIndex].like,
      liked: this.items[aIndex][iIndex].liked,
      price: this.items[aIndex][iIndex].price,
      aIndex: aIndex,
      iIndex: iIndex
    };

    console.log(this.heightPop);

    this.foodDetailState = 'food-detail-up';
    this.iconClicked = true;
    if (!this.subMenu) {
      this.subMenu = JSON.parse(this._okageStorage.getItem('foods.submenu'));
    }
    for (var i = 0; i < this.items.length; i++) {
      for (var j = 0; j < this.items[i].length; j++) {
      //if (this.iCounter[i]) {
        //for (var j = 0; j < this.iCounter[i].length; j++) {
          //if (this.iCounter[i][j]) {
            if (typeof this.subMenu[this.items[i][j].id] !== 'undefined') {
              this.items[i][j].sub = this.subMenu[this.items[i][j].id];
            }
          //}
        //}
      //}
      }
    }
    //console.log(this.items);
  }

  hideDetailPopup() {
    if (!this.iconClicked) {
      this.foodDetailState = '';
      this.heightPop = '';
    } else {
      this.iconClicked = false;
    }
  }

  chooseFood(aIndex, iIndex) {
    if (this.iconClicked) {
      return;
    }
    if (!this.iCounter[aIndex]) {
      this.iCounter[aIndex] = [];
    }
    if (!this.iCounter[aIndex][iIndex]) {
      this.iCounter[aIndex][iIndex] = 0;
    }
    this.iCounter[aIndex][iIndex]++;
    this.storage.set('foods.selected', this.iCounter).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 1);
    });
  }

  removeFood(aIndex, iIndex, desFromImage) {
    if (desFromImage) {
      this.iconClicked = true;
    }
    if (!this.iCounter[aIndex][iIndex]) {
      return;
    }
    this.iCounter[aIndex][iIndex]--;
    this.storage.set('foods.selected', this.iCounter).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 1);
    });
  }

  clicksubDescrease(menuid, subindex) {
    if (!this.subMenu[menuid][subindex]) {
      return;
    }
    if (this.subMenu[menuid][subindex].quantity <= 0) {
      return;
    }
    this.subMenu[menuid][subindex].quantity--;

    this.countTotal();
    this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subMenu));
    this.broadcaster.broadcast('submenuChanged', 1);
    this.updateMenuQuantity(menuid);
  }

  clicksubIncrease(menuid, subindex) {
    this.subMenu[menuid][subindex].quantity++;

    this.countTotal();
    this._okageStorage.setItem('foods.submenu', JSON.stringify(this.subMenu));
    this.broadcaster.broadcast('submenuChanged', 1);
    this.updateMenuQuantity(menuid);
  }

  updateMenuQuantity(menuid) {
    let _total = 0;
    for(let k = 0; k < this.subMenu[menuid].length; k++) {
      _total += this.subMenu[menuid][k].quantity;
    }
    this.iCounter[this.currentItem.aIndex][this.currentItem.iIndex] = _total;
    this.storage.set('foods.selected', this.iCounter).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 1);
    });
  }

  private countTotal() {
    var total = 0;
    for(var i = 0; i < 3; i++) {
      if (this.iCounter[i]) {
        for(var j = 0; j < this.iCounter[i].length; j++) {
          if (this.iCounter[i][j]) {
            total += this.iCounter[i][j];
          }
        }
      }
    }
    this.iTotal = total;
    this.storage.set('iTotal', this.iTotal);
  }

  like(aIndex, iIndex) {
    if (!this.items[aIndex][iIndex].liked) {
      this.items[aIndex][iIndex].liked = true;
      this.items[aIndex][iIndex].like++;
      this.storage.set('foods.menu', this.items).then((a) => {
        this.broadcaster.broadcast('foodLikeChanged', 1);
        this._apiService.like(this.items[aIndex][iIndex].id).subscribe(
        (result) => {
          console.log(result);
        });
      });
    } else {
      this.items[aIndex][iIndex].liked = false;
      this.items[aIndex][iIndex].like--;
      this.storage.set('foods.menu', this.items).then((a) => {
        this.broadcaster.broadcast('foodLikeChanged', 1);
        this._apiService.unlike(this.items[aIndex][iIndex].id).subscribe(
        (result) => {
          console.log(result);
        });
      });
    }
  }

	ionViewDidLoad() {
            if(!this.items){
                this.storage.get('foods.menu').then((v) => {
                    this.items = v;
                    this.foodCounterChanged();
                });
            }
	}
	selectTab(index) {
		this.pageSlider.slideTo(index);
	}

	changeWillSlide($event) {
	 	this.tabs = $event._snapIndex.toString();
	}

  sendOrder() {
    this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/grid/grid.ts